module.exports = require('./lib/no-important.js');



//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/guest-payment/~/aphrodite/no-important.js
// module id = 354
// module chunks = 6